import React, { useEffect, useRef } from 'react';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

import Tile from './tile';
import Animation from './animation';


const TileGroup = ({ tileGroup, currentDialog, setDialog, unsetDialog }) => {
    const tilesEl = useRef(null);

    useEffect(() => {
        imagesLoaded(tilesEl.current, () => {
            new Masonry(tilesEl.current, {
                itemSelector: '.tiles__tile',
                percentPosition: true,
                transitionDuration: 0,
            });
        });
    });

    const { heading, first, subheading, animations, tiles } = tileGroup;

    return (
        <>
            { heading && (
                first ? (
                    <h3
                        className={ `color-dark-blue text-center md:c6 md:o3 py-4 ${ subheading ? '' : 'pb-12 md:pb-24' }` }
                        dangerouslySetInnerHTML={{ __html: heading }}
                    />
                ) : (
                    <h4
                        className={ `font-bold color-dark-blue text-center md:c6 md:o3 py-4 ${ subheading ? '' : 'pb-12 md:pb-24' }` }
                        dangerouslySetInnerHTML={{ __html: heading }}
                    />
                )
            ) }
            { subheading && (
                <h5
                    className='color-dark-blue text-center py-4 md:c10 md:o1 pb-12 md:pb-24'
                    dangerouslySetInnerHTML={{ __html: subheading }}
                />
            ) }
            <div ref={ tilesEl } className='grid tiles md:pb-24'>
                { tiles && tiles.map(tile => (
                    <Tile
                        key={ tile.filename }
                        tile={ tile }
                        currentDialog={ currentDialog }
                        setDialog={ setDialog }
                        unsetDialog={ unsetDialog }
                    />
                )) }
                { animations && animations.map((animation, key) => <Animation key={ key } animation={ animation } />) }
            </div>
        </>
    );
};

export default TileGroup;
